module.exports = __webpack_public_path__ + "static/floating-action-button-action-secondary-dont-36557bfede16a5352fff491e7c8235c6.png";